import { action } from 'satcheljs';

export let completeSendAnEmail = action('COMPLETE_SEND_AN_EMAIL');
